import styled from "styled-components";

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;
